import { commonFilter } from './filter';

export default {
  pageName: 'Competitor',
  pageId: '20025',
  pagePath: '/opinion/Competitor',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
